import { useState, useCallback, useEffect } from 'react';
import notificationService from '../services/notificationService';

const EMPTY_SUMMARY = {
  total: 0,
  unread: 0,
  read: 0,
  byType: { ALERT: 0, INFO: 0, WARNING: 0, SUCCESS: 0 }
};

/**
 * Résumé des notifications de l'utilisateur courant (badge header / menu).
 */
export function useNotificationSummary({ pollMs = 60000, enabled = true } = {}) {
  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (signal) => {
    if (!enabled) return;
    try {
      setLoading(true);
      const response = await notificationService.summary({ signal });
      if (response?.data) {
        setSummary({ ...EMPTY_SUMMARY, ...response.data });
      }
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('Résumé notifications:', error);
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    refresh(controller.signal);
    return () => controller.abort();
  }, [refresh, enabled]);

  useEffect(() => {
    if (!enabled || !pollMs) return undefined;
    const id = setInterval(() => {
      const controller = new AbortController();
      refresh(controller.signal);
    }, pollMs);
    return () => clearInterval(id);
  }, [refresh, pollMs, enabled]);

  return { summary, unread: summary.unread, loading, refresh };
}
